import { ResponseGenerator } from 'common/type';
import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';

import { getFilterContainerAPI, updateFilterContainerAPI } from './api';
import { filterContainer, filterContainerSuccess, updateContainer, updateContainerSuccess } from './slice';

function* filterContainerSaga({ payload }: any) {
  const { filterParam, filterContainerSuccessLocal, filterContainerFailLocal } = payload;

  try {
    const response: ResponseGenerator = yield call(getFilterContainerAPI, filterParam);
    yield put(filterContainerSuccess(response?.data));
    filterContainerSuccessLocal(response?.data);
  } catch (error) {
    filterContainerFailLocal();
  }
}

function* updateContainerSaga({ payload }: any) {
  const { onSucess, onFail, data } = payload;

  try {
    const response: ResponseGenerator = yield call(updateFilterContainerAPI, data);
    yield put(updateContainerSuccess(response));
    onSucess();
  } catch (error) {
    onFail();
  }
}

function* watchContainerStatus() {
  yield takeEvery(filterContainer, filterContainerSaga);
  yield takeLatest(updateContainer, updateContainerSaga);
}

export default watchContainerStatus;
